<template>
  <div class="pagenotfound data--center">
    <button @click="goRootPage">Go to Login</button>
    <span>Page Not found</span>
  </div>
</template>

<script>
import {useRouter} from "vue-router";

export default {
  name: "PageNotFound",
  setup() {

    const router = useRouter();

    const goRootPage = () => {
      router.push({path: '/'});
    };

    return {
      goRootPage
    }
  }
}
</script>

<style scoped>
.pagenotfound {
  font-size: 2rem;
  font-weight: bold;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
